import { UtilityService } from '@eforall/common';
import { FilterOperator, GridColumn, buildColumn } from '@eforall/dashboard';
import { VolunteerTopic } from '@interfaces';
import { DomainDataService } from '../../../../../../services';


export function getColumns(util: UtilityService, domainData: DomainDataService) {

	const columns: GridColumn<VolunteerTopic, unknown>[] = [
		buildColumn(util, 'Text', row => domainData.data().topicsMap[row.topicId]?.name, { header: 'Topic' }),
		buildColumn(util, 'Text', row => row.isApproved ? 'Approved' : 'Not Approved', { header: 'Status' }),
		buildColumn(util, 'Text', row => row.note, { header: 'Note' }),
		buildColumn(util, 'TrueFalse', row => domainData.data().topicsMap[row.topicId]?.enabled, { header: 'Enabled', hidden: true, filter: { operator: FilterOperator.EqualTo, value: true } }),
	];

	return columns;

}